/**
 * Hokage → Carina 移行 UI（モーダル・バナー・移行画面）の公開範囲。
 * - "off": 誰にも出さない
 * - "office": 社内 IP（VITE_DEBUG_ALLOWED_IPS）のときだけ出す
 * - "all": Hokage(93) の全員に出す（オーガニック(1093) は BE が移行しないため対象外）
 * BE・Carina・Hokage ネイティブのリリースがすべて完了してから "office" → "all" と広げる。
 */
export type HokageMigrationRollout = "off" | "office" | "all";

export const HOKAGE_MIGRATION_ROLLOUT = "all" as HokageMigrationRollout;

/**
 * Hokage のサービス終了日（文言に埋め込む表記）。
 */
export const HOKAGE_SERVICE_END_DATE_TEXT = "2026年11月4日 12:00";

/**
 * Carina を開く／入れるためのリンク（Adjust のトラッキングリンク）。
 * BE は 93→95（裏→裏）しか移行しないため、Carina の裏の画面（95）に着地させる必要がある。
 * App Store の URL を直接開くと Organic 扱いになり表の画面（1095）に入るため、移行されない。
 * NOTE: Adjust の流入元はインストール時に決まるため、Carina をすでに表で入れている人は表のままになる（個別対応）。
 */
export const CARINA_APP_STORE_URL =
  "https://carina.go.link/migrate?adj_t=25vzlnf7";

/**
 * Hokage のサービス終了日時。これ以降は Hokage(93/1093) をログアウトしてサービス終了画面へ送る。
 * 公開範囲 HOKAGE_MIGRATION_ROLLOUT とは独立（終了は全員対象）。
 */
export const HOKAGE_SERVICE_CUTOFF_AT = "2026-11-04T12:00:00+09:00";

/** サービス終了画面のパス */
export const HOKAGE_SERVICE_ENDED_PATH = "/hokage-service-ended";
